import styled from "styled-components";

const Container = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: black;
`;

const Bi = () => {
  return <Container>FollowingMoments</Container>;
};

export default Bi;
